
import './AddProfileTitle.scss';
export default function AddProfileTitle(props: any) {
    return (
        <div className="sc-bWFPNQ bKYUNa "><h2 className="text-color--primary">Add Profile</h2></div>
    );
}